module.exports = __webpack_public_path__ + "static/media/cristina-logo.07e54f94.png";